module.exports = __webpack_public_path__ + "img/guide.4da46ac4.png";